import { CSSProperties } from "react";
import { theme } from "antd";

export function HeatmapIcon(props: {
  style?: CSSProperties;
  size?: number;
  inactive?: boolean;
}) {
  const { token } = theme.useToken();
  const size = props.size === undefined ? 16 : props.size;
  if (size <= 20)
    return <Small style={props.style} inactive={props.inactive} />;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <rect
          width="5.79"
          height="4.29167"
          transform="translate(0.748291 0.5625)"
          fill={token.colorText}
        />
        <g opacity="0.8">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(7.03833 0.5625)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.6">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(13.3282 0.5625)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.8">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(0.748291 5.35417)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.6">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(7.03833 5.35417)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.4">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(13.3282 5.35417)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.6">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(0.748291 10.1458)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.4">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(7.03833 10.1458)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.2">
          <rect
            width="5.79"
            height="4.29167"
            transform="translate(13.3282 10.1458)"
            fill={token.colorText}
          />
        </g>
      </g>
    </svg>
  );
}

function Small(props: { style?: CSSProperties; inactive?: boolean }) {
  const { token } = theme.useToken();
  if (props.inactive) return <Inactive style={props.style} />;
  return (
    <svg
      style={props.style}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.9">
        <rect
          width="4.5"
          height="4.5"
          transform="translate(0.5 0.5)"
          fill={token.colorText}
        />
        <g opacity="0.8">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(5.5 0.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.6">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(10.5 0.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.8">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(0.5 5.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.6">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(5.5 5.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.4">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(10.5 5.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.6">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(0.5 10.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.4">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(5.5 10.5)"
            fill={token.colorText}
          />
        </g>
        <g opacity="0.2">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(10.5 10.5)"
            fill={token.colorText}
          />
        </g>
      </g>
    </svg>
  );
}

function Inactive(props: { style?: CSSProperties }) {
  const { token } = theme.useToken();
  return (
    <svg
      style={props.style}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <rect
          width="4.5"
          height="4.5"
          transform="translate(0.5 0.5)"
          fill={token.colorTextTertiary}
        />
        <g opacity="0.4">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(5.5 0.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.3">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(10.5 0.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.4">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(0.5 5.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.3">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(5.5 5.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.2">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(10.5 5.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.3">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(0.5 10.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.2">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(5.5 10.5)"
            fill={token.colorTextTertiary}
          />
        </g>
        <g opacity="0.1">
          <rect
            width="4.5"
            height="4.5"
            transform="translate(10.5 10.5)"
            fill={token.colorTextTertiary}
          />
        </g>
      </g>
    </svg>
  );
}
